<template>
    <div class="bg-violet text-white p-lg-6" style="font-size: 16px">
        <div class="d-xl-flex row p-lg-0">
            <div class="col-xl-6 col-12 p-lg-0">
                <div class="row">
                    <div class="col-xl-3 col-lg-3 col-md-12 col-12">
                        <img :src="publicPath + 'media/logo-svg.svg'" class="logo-edutalk" alt="Edutalk Tư Vấn"
                             aria-roledescription="logo" style="height: 100px; margin-top: -30px" >
                    </div>
                    <div class="col-xl-4 col-lg-4 col-md-12 col-12 pt-4">
                        <el-select clearable v-model="query.user_ids" multiple filterable collapse-tags class="w-100"
                                   placeholder="Chọn RSM" @change="getData()">
                            <el-option
                                v-for="item in users"
                                :key="item.id"
                                :label="item.name"
                                placeholder="Chọn RSM"
                                :value="item.id">
                                <span style="float: left">{{ item.name }}</span>
                            </el-option>
                        </el-select>
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-12 col-12 pt-4">
                        <el-date-picker
                            v-model="query.date_range"
                            type="daterange"
                            range-separator="To"
                            start-placeholder="Start date"
                            @change="getData"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            end-placeholder="End date">
                        </el-date-picker>
                    </div>
                </div>
                <div class="row col-12 mt-6 custom-background rounded p-4 m-0">
                    <div class="col-xl-6">
                        <h3>Tổng doanh thu (Kinh doanh)</h3>
                        <h1 style="font-size: 25px">{{ (totalCurrentYear) |formatVND }}</h1>
                        <h4>
                            <span :class="!percent ? 'text-warning' : 'text-green'">
                                <i class="el-icon-download" v-if="!percent"></i>
                                <i class="el-icon-upload2" v-else></i>{{ percent }}%
                            </span>
                            <span>so với cùng thời điểm năm trước</span>
                        </h4>
                    </div>
                    <div class="col-xl-6">
                        <h3>TB. Doanh thu / Văn phòng</h3>
                        <h2 style="font-size: 25px">{{ (totalCurrentYear / totalBranchCurrentYear) |formatVND }}</h2>
                        <h4>
                            <span :class="percentQte < 0 ? 'text-warning' : 'text-green'">
                                <i class="el-icon-download" v-if="!percentQte"></i>
                                <i class="el-icon-upload2" v-else></i>
                                {{ percentQte }}%
                            </span>
                            <span>so với năm trước</span>
                        </h4>
                    </div>
                </div>
            </div>
            <div class="col-xl-6 col-12 mt-4 mt-xl-0 p-0">
                <div class="d-xl-flex rounded col-md-12 text-center" style="margin-top: 75px">
                    <canvas id="chart-table" style="z-index: auto !important; position: relative; height: 200px!important"></canvas>
                </div>
            </div>
        </div>
        <div class="row mt-4 d-flex">
            <div class="col-xl-4 col-lg-4 col-md-4 col-12">
                <canvas id="doughnutChart" style="width: 357px!important; height: 357px; margin-top: 30px; "></canvas>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-12">
                <canvas id="doughnutChart2"  style="width: 357px; height: 357px; margin-top: 30px; "></canvas>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-12">
                <canvas id="doughnutChart3"  style="width: 357px; height: 357px; margin-top: 30px; "></canvas>
            </div>
        </div>
        <div class="col-md-12 row">
            <div class="col-md-4 mt-4">
                <div style="height: 100%" class="p-4 background-linear">
                    <div style="font-weight: bold; font-size: 20px; color: black!important;" class="pb-4"> Chi tiết đội </div>
                    <div class="table-responsive">
                        <table class="table-report w-100 text-left table" style="font-size: 15px">
                        <thead class="custom-thead">
                            <tr>
                                <th>Đội</th>
                                <th>% Chỉ tiêu</th>
                                <th>Doanh số</th>
                            </tr>
                        </thead>
                        <tbody class="custom-tbody">
                            <tr v-for="(item, index) in doughnut" :key="index" class="p-2">
                                <td>{{ define[item.customer_channel] }}</td>
                                <td>{{ item.percent }} %</td>
                                <td>{{ item.amount_business_coefficient |formatVND }}</td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>
            <div class="col-md-4 mt-4">
                <div class="p-4 background-linear">
                    <div style="font-weight: bold; font-size: 20px; color: black!important;" class="pb-4"> Chi tiết nguồn </div>
                    <div class="table-responsive">
                        <table class="table-report w-100 text-left table" style="font-size: 15px">
                            <thead class="custom-thead">
                                <tr>
                                    <th>Nguồn</th>
                                    <th>% Chỉ tiêu</th>
                                    <th>Doanh số</th>
                                </tr>
                            </thead>
                            <tbody class="custom-tbody">
                                <tr v-for="(item, index) in doughnut2" :key="index" class="p-2">
                                    <td>{{ item.nguon }}</td>
                                    <td>{{ item.percent }} %</td>
                                    <td>{{ item.amount_business_coefficient |formatVND}}</td>

                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="col-md-4 mt-4 ">
                <div style="height: 100%" class="p-4 background-linear">
                    <div style="font-weight: bold; font-size: 20px; color: black!important;" class="pb-4"> Chi tiết RSM </div>
                    <div class="table-responsive">
                        <table class="table-report w-100 text-left table" style="font-size: 15px">
                        <thead class="custom-thead">
                            <tr>
                                <th>RSM</th>
                                <th>Doanh số</th>
                            </tr>
                        </thead>
                        <tbody class="custom-tbody">
                            <tr v-for="(item, index) in doughnut3" :key="index" class="p-2">
                                <td>{{ item.name }}</td>
                                <td>{{ item.total_amount |formatVND}}</td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    Chart as ChartJS,
    Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale,
} from 'chart.js'
import Chart from 'chart.js/auto';
import {
    REPORT_LIST_RSM,
    REPORT_RSM_DOANH_THU_THUC_TE
} from "../../../core/services/store/report.module";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)

export default {
    // doanh thu thực tế
    name: "ActualSales",
    data()
    {
        return {
            salesData: [
                {
                    region: 'HN01',
                    office: 'Đặng Thủy Trâm',
                    manager: 'Lâm Hà Trang',
                    monthlySales: [10, 20000000, 15, 25, 30, 28, 350000000, 40, 38, 45, 50, 55000000000]
                }
            ],
            data: [],
            dataLastYear: [],
            doughnut: [],
            doughnut2: [],
            doughnut3: [],
            publicPath: process.env.VUE_APP_BASE_URL,
            totalCurrentYear: 0,
            totalLastYear: 0,
            percent: 0,
            define: ['Khác', 'Đội kinh doanh','Digital Marketing','Liên kết trường'],
            query: {
                date_range: ['2025-01-01', '2025-12-31'],
                user_ids: []
            },
            users: [],
            chartInstance: null,
            chartInstanceDoughnut: null,
            chartInstanceDoughnut2: null,
            chartInstanceDoughnut3: null,
            chartConfig : null,
            totalBranchCurrentYear: 0,
            totalBranchLastYear: 0,
            percentQte: 0
        }
    },
    mounted() {
        this.$store.dispatch(SET_BREADCRUMB, [
            {title: "Báo cáo kênh", icon: 'far fa-chart-bar'}
        ]);
        this.getData();
        this.getUsers();
    },
    methods: {
        getUsers()
        {
            this.$store.dispatch(REPORT_LIST_RSM, {}).then((res) => {
                this.users = res.data;
            });
        },
        getData()
        {
            this.$store.dispatch(REPORT_RSM_DOANH_THU_THUC_TE, this.query).then((res) => {
                this.data = res.data.data_current_year_by_month;
                this.dataLastYear = res.data.data_last_year_by_month;
                this.doughnut = this.handleData(res.data.data_kenh_kh);
                this.doughnut2 = this.handleData(res.data.data_nguon_kh);
                this.doughnut3 = res.data.totals_by_user;
                this.showDataRSMBar();
                this.showDataRSMDoughnut();
                this.showDataRSMDoughnut2();
                this.showDataRSMDoughnut3();

                this.totalCurrentYear = this.data.reduce((total, item) => total + Number(item.amount_business_coefficient), 0);

                this.totalLastYear = this.dataLastYear.reduce((total, item) => total + Number(item.amount_business_coefficient), 0);
                this.percent = this.totalLastYear > 0 ? Math.ceil((this.totalCurrentYear / this.totalLastYear) * 100) : 0;
                this.totalBranchCurrentYear = this.data.length;
                this.totalBranchLastYear = this.dataLastYear.length;

                this.percentQte = this.totalLastYear ? Math.ceil(((this.totalCurrentYear - this.totalLastYear) / this.totalLastYear) * 100) : 0;

            });
        },
        handleData(data)
        {
            const totalAmount = data.reduce((total, item) => total + Number(item.amount_business_coefficient), 0);

            return data.map((item) => {
                item.percent = (item.amount_business_coefficient / totalAmount * 100).toFixed(2);
                return item;
            });
        },
        showDataRSMBar()
        {
            const monthlySales = this.data.map(user => user.amount_business_coefficient);
            const monthlyLastYearSales = this.dataLastYear.map(user => user.amount_business_coefficient);
            const canvasId = 'chart-table';

            const ctx = document.getElementById(canvasId)?.getContext('2d');
            const maxNumber = Math.max(...monthlySales) > Math.max(...monthlyLastYearSales) ? parseInt(Math.max(...monthlySales)) : parseInt(Math.max(...monthlyLastYearSales))
            const stepSize = maxNumber/3

            let chartConfig = {
                type: 'bar',
                data: {
                    labels: [
                        'T1', 'T2', 'T3', 'T4', 'T5', 'T6',
                        'T7', 'T8', 'T9', 'T10', 'T11', 'T12'
                    ],
                    datasets: [
                        {
                            label: `Doanh thu ` + (new Date()).getFullYear(),
                            data: monthlySales,
                            backgroundColor: '#b2f2bb',
                            barThickness: 20
                        },
                        {
                            label: `Doanh thu ` + ((new Date()).getFullYear() - 1),
                            data: monthlyLastYearSales,
                            backgroundColor: '#FFECB3',
                            barThickness: 20
                        }
                    ]
                },
                options: {
                    responsive: false,
                    maintainAspectRatio: true,
                    min: 0,
                    max: 100,
                    layout: {
                        padding: 10
                    },
                    scales: {
                        y: {
                            beginAtZero: true,
                            min: 0,
                            max: maxNumber,
                            ticks: {
                                stepSize: stepSize,
                                color: '#fff',
                                font: { size: 12, weight: 'bold' },
                                callback: function(value) {
                                    if (value >= 1000000000) {
                                        return Math.ceil(value / 1000000000) + ' tỉ';
                                    }
                                    if (value >= 1000000) {
                                        return Math.ceil(value / 1000000) + ' triệu';
                                    }
                                    return Math.ceil(value);
                                }
                            },
                            grid: {
                                color: 'rgba(255,255,255,0.2)',
                                drawBorder: true
                            }
                        },
                        x: {
                            ticks: {
                                color: '#fff',
                                font: {
                                    size: 10
                                }
                            },
                            grid: {
                                display: false
                            }
                        }
                    },
                    plugins: {
                        legend: { display: false },
                        tooltip: { enabled: true }
                    }
                }
            }

            if (this.chartInstance) {
                this.updateChartData(monthlySales, monthlyLastYearSales, maxNumber, stepSize);
            } else {
                this.chartInstance = new Chart(ctx, chartConfig);
            }

        },
        showDataRSMDoughnut()
        {
            const totalAmount = this.doughnut.reduce((total, item) => total + Number(item.amount_business_coefficient), 0);
            const monthlySales = this.doughnut.map(user => (user.amount_business_coefficient / totalAmount * 100).toFixed(2));

            const ctxDoughnut = document.getElementById('doughnutChart');
            this.resetDoughnutChartData(this.chartInstanceDoughnut);

            this.chartInstanceDoughnut = new Chart(ctxDoughnut, {
                type: 'doughnut',
                data: {
                    labels: this.define,
                    datasets: [
                        {
                            label: 'Outer',
                            data: monthlySales,
                            backgroundColor: [
                                '#f1f4c5', '#d0d2f7', '#96b3f7', '#a1d6f7', '#f1b7c4',
                                '#f3d3b7', '#f4aa7b', '#f45b2d', '#e9745d', '#8d1507'
                            ],
                            borderWidth: 0.5,
                            hoverOffset: 10
                        },
                        {
                            label: 'Inner',
                            data: Array(10).fill(1),
                            backgroundColor: Array(10).fill('rgb(47, 28, 74)'),
                            borderWidth: 0
                        }
                    ]
                },
                options: {
                    cutout: '5%',
                    cutoutPercentage: 60,
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: {
                        padding: {
                            right: 50
                        }
                    },
                    plugins: {
                        legend: {
                            position: 'right',
                            labels: {
                                usePointStyle: true,
                                color: '#fff',
                                font: {
                                    size: 10
                                }
                            },
                            maxWidth: 375
                        },
                        tooltip: {
                            callbacks: {
                                label: ctx => {
                                    const value = ctx.parsed;
                                    const label = ctx.label;
                                    return `${label}: ${value}%`;
                                }
                            }
                        }
                    }
                }
            });

        },
        showDataRSMDoughnut2()
        {
            const totalAmount = this.doughnut2.reduce((total, item) => total + Number(item.amount_business_coefficient), 0);
            const monthlySales = this.doughnut2.map(user => (user.amount_business_coefficient / totalAmount * 100).toFixed(2));
            const customer_channel = this.doughnut2.map(user => user.nguon);
            this.resetDoughnutChartData(this.chartInstanceDoughnut2)

            const ctxDoughnut = document.getElementById('doughnutChart2');
            this.chartInstanceDoughnut2 = new Chart(ctxDoughnut, {
                type: 'doughnut',
                data: {
                    labels: customer_channel,
                    datasets: [
                        {
                            label: 'Outer',
                            data: monthlySales,
                            backgroundColor: [
                                '#f1f4c5', '#d0d2f7', '#96b3f7', '#a1d6f7', '#f1b7c4',
                                '#f3d3b7', '#f4aa7b', '#f45b2d', '#e9745d', '#8d1507'
                            ],
                            borderWidth: 0,
                            hoverOffset: 10
                        },
                        {
                            label: 'Inner',
                            data: Array(10).fill(1),
                            backgroundColor: Array(10).fill('rgb(47, 28, 74)'),
                            borderWidth: 0
                        }
                    ]
                },
                options: {
                    layout: {
                        padding: {
                            right: 50
                        }
                    },
                    cutout: '5%',
                    cutoutPercentage: 60,
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            position: 'right',
                            labels: {
                                usePointStyle: true,
                                color: '#fff',
                                font: {
                                    size: 10
                                }
                            },
                            maxWidth: 375

                        },
                        tooltip: {
                            callbacks: {
                                label: ctx => {
                                    const value = ctx.parsed;
                                    const label = ctx.label;
                                    return `${label}: ${value}%`;
                                }
                            }
                        }
                    }
                }
            });
        },
        showDataRSMDoughnut3()
        {
            const totalAmount = this.doughnut3.reduce((total, item) => total + Number(item.total_amount), 0);
            const monthlySales = this.doughnut3.map(user => (user.total_amount / totalAmount * 100).toFixed(2));
            const customer_channel = this.doughnut3.map(user => user.name);
            this.resetDoughnutChartData(this.chartInstanceDoughnut3);
            const ctxDoughnut = document.getElementById('doughnutChart3');
            this.chartInstanceDoughnut3 = new Chart(ctxDoughnut, {
                type: 'doughnut',
                data: {
                    labels: customer_channel,
                    datasets: [
                        {
                            label: 'Outer',
                            data: monthlySales,
                            backgroundColor: [
                                '#f1f4c5', '#d0d2f7', '#96b3f7', '#a1d6f7', '#f1b7c4',
                                '#f3d3b7', '#f4aa7b', '#f45b2d', '#e9745d', '#8d1507'
                            ],
                            borderWidth: 0,
                            hoverOffset: 10
                        },
                        {
                            label: 'Inner',
                            data: Array(10).fill(1),
                            backgroundColor: Array(10).fill('rgb(47, 28, 74)'),
                            borderWidth: 0
                        }
                    ]
                },
                options: {
                    layout: {
                        padding: {
                            right: 50
                        }
                    },
                    cutout: '5%',
                    cutoutPercentage: 60,
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: {
                            position: 'right',
                            labels: {
                                usePointStyle: true,
                                color: '#fff',
                                font: {
                                    size: 10
                                }
                            },
                            maxWidth: 375

                        },
                        tooltip: {
                            callbacks: {
                                label: ctx => {
                                    const value = ctx.parsed;
                                    const label = ctx.label;
                                    return `${label}: ${value}%`;
                                }
                            }
                        }
                    }
                }
            });
        },
        updateChartData(monthlySales, monthlyLastYearSales, maxNumber, stepSize) {
            if (!this.chartInstance) return;

            try {
                this.chartInstance.data.datasets[0].data = monthlySales;
                this.chartInstance.data.datasets[1].data = monthlyLastYearSales;

                this.chartInstance.options.scales.y.max = maxNumber || 100;
                this.chartInstance.options.scales.y.ticks.stepSize = stepSize;

                this.chartInstance.update('active');

            } catch (error) {
                console.error('Lỗi khi update chart:', error);
                this.forceRecreateChart();
            }
        },
        forceRecreateChart() {
            const canvasId = 'chart-table';
            const canvas = document.getElementById(canvasId);

            if (!canvas) return;

            if (this.chartInstance) {
                this.chartInstance.destroy();
                this.chartInstance = null;
            }

            const parent = canvas.parentNode;
            const newCanvas = document.createElement('canvas');
            newCanvas.id = canvasId;
            newCanvas.width = canvas.width;
            newCanvas.height = canvas.height;

            Array.from(canvas.attributes).forEach(attr => {
                if (attr.name !== 'id') {
                    newCanvas.setAttribute(attr.name, attr.value);
                }
            });

            parent.replaceChild(newCanvas, canvas);

            const ctx = newCanvas.getContext('2d');
            this.chartInstance = new Chart(ctx, this.chartConfig);
        },
        resetDoughnutChartData(chartInstanceDoughnut) {
            if (chartInstanceDoughnut) {
                chartInstanceDoughnut.destroy();
                chartInstanceDoughnut = null;
            }
        }
    }

}
</script>
<style scoped>
    .bg-violet {
        background-color: rgb(47, 28, 74);
    }
    #chart-table {
        width: 100%;
        height: 100px;
        display: block;
    }
    .custom-background {
        background: rgb(91 63 131)!important;
        border-radius: 15px!important;
    }
    .background-linear {
        background: rgba(255, 255, 255, 0.9)!important;
        border-radius: 15px;
    }
    .custom-thead {
        background: rgba(139, 92, 246, 0.05);
    }
    .custom-tbody {
        background: white;
        color: black!important;
    }
    .table tbody tr:hover {
        background: rgba(102, 51, 153, 0.3);
    }
    .text-green {
        color: #54cf68;
    }

</style>
